import React, { Component } from 'react'
import styled from 'styled-components'
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

const SliderWrapper = styled.div`
  width: 100%;
  padding: ${props => (props.padding ? props.padding : '24px 0')};
  & > div {
    height: 4px !important;
    border-radius: 10px !important;
    background: #ebebeb !important;
    & > div:first-child {
      background-color: #078489 !important;
    }
    & > div:nth-child(2) {
      min-width: 24px !important;
      min-height: 24px !important;
      border-radius: 50% !important;
      background-color: #078489 !important;
      box-shadow: none !important;
      border: none !important;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      &:after {
        position: static !important;
        width: 0 !important;
        height: 0 !important;
      }
    }
  }
  ul > li {
    width: 50px !important;
    padding-top: 2px;
    &:first-child {
      margin-right: 24px;
      text-align: right;
    }
    &:last-child {
      margin-left: 14px;
    }
  }
`
class StyledSlider extends Component {
  render() {
    const { horizontalLabels, key, value, format, handleLabel, padding, ...props } = this.props
    return (
      <SliderWrapper padding={padding}>
        <Slider
          value={value}
          key={key}
          labels={horizontalLabels}
          format={format}
          handleLabel={handleLabel}
          {...props}
        />
      </SliderWrapper>
    )
  }
}

export default StyledSlider



// WEBPACK FOOTER //
// ./src/components/StyledSlider.js